import React, { /*Component*/ } from 'react';

import { NodeSpinner } from '../../components/NodeSpinner';
import DateAlive from '../../components/DateAlive';
import { Edit, Delete, TransparentEditBox } from '../../components/Edit';
import { Treelink, TransparentTreeBox } from '../../components/Treelink';
import { ResolveWarning, TransparentResolveWarning } from '../../components/Resolve/ResolveWarning';
import { PendingMerge, TransparentPendingMerge } from '../../components/PendingMerge';
import { InconsistencyText, InconsistencyCircle, TransparentInconsistencyCircle } from '../../components/Inconsistency';
import { Dna, DnaBox } from '../../components/Dna';
import { Gedcom, GedcomTransparentBox } from '../../components/Gedcom';
import GhostLabel from '../../components/GhostLabel';
import { Pic, Deadbanner, PresummedDeadBanner } from '../../components/Pic';
import { FrameBorder } from '../../components/DualPedigree/FrameBorder/';
import { Node/*, NodeSvg*/, HighLightNode, ShadowNode } from '../../components/Node';
// import { Viewport } from '../../components/Viewport';
import DragNode from '../../components/Move/DragNode';
import assembleFullNameForOneNode from '../../components/FullName';
import assembleCycleForOneNode from '../../components/Cycle';
import assembleBubbleForOneNode from '../../components/Matches/bubble/';
import assembleToolTipForOneNode from '../../components/Tooltip';
import assembleMagnifyCountForOneNode from '../../components/Matches/magnifycount/';
import assembleInviteForOneNode from '../../components/Invite/';
import assembleAddnodeTabForOneNode from '../../components/AddnodeTab/';
import assembleMultipleParentsForOneNode from '../../components/MultipleParents/';
import assemblePruneTreeForOneNode from '../../components/Prune';
import Unionline from '../../components/Line';
import assembleGoalPost from '../../components/Goalpost';
import { assemblePedbranchLines, assemblePedbranchAddTab } from '../../components/Pedigree';
import assembleT from '../../components/T';

import {
  viewPortBuffer,
  isDevelopment,
  isSeinfeld,
  dualPedigreeMode,
  no_decoration,
} from '../../library/constants';

import {
  isMobilePhone,
  isMobileTablet,
  isUnionAboveGrandparentNodeRowNrelated,
  bothPartnersDirectlyRelated,
  getUnionLineCoordsForPartners,
  getCenterXFromChildren,
  isNodeWithinViewport,
  isUnionWithinViewport,
  unionHasDescedants,
  unionIsPartnersOfTwoNodes,
  resetSideYPointIdx,
  screenCanShowModal,
  urlGet,
} from '../../library/calc';

import assets from './assets';
import Build from './0_build';

export default class AssembleTree extends Build{ // eslint-disable-line react/prefer-stateless-function


  gatherTreeComponents({n, nodeObj}){

    const {
      setPrId,
      fetchTree,
      unsetNodeObjGedcom,
    } = this.props;

    const methodProps = {
      n,
      node: n,
      // key: `${n}-${idx}`,
      key: `${n}`,
      unsetNodeObjGedcom,
      onClickedNode: this.onClickedNode.bind(this),
      highlight: this.highlight.bind(this),
      unhighlight: this.unhighlight.bind(this),
      nodeIsGhost: this.nodeIsGhost.bind(this),
      setNodeForFlipFocus: this.setNodeForFlipFocus.bind(this),
      storePrIdToLocationHistory: this.storePrIdToLocationHistory.bind(this),
      setShowMobileFlipCard: this.setShowMobileFlipCard.bind(this),
      setFlipCardScreenIsOn: this.setFlipCardScreenIsOn.bind(this),
      onClickEdit: this.onClickEdit.bind(this),
      onClickDelete: this.onClickDelete.bind(this),
      onClickedInvite: this.onClickedInvite.bind(this),
      cursorBecomesMove: this.cursorBecomesMove.bind(this),
      cursorBecomesPointer: this.cursorBecomesPointer.bind(this),
      userTouchedNode: this.userTouchedNode.bind(this),
      touchMoveDisabled: this.touchMoveDisabled,
      stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
      panAnimateToNode: this.panAnimateToNode.bind(this),
      hideMatchBubble: this.hideMatchBubble.bind(this),
      setCacheBreakPicsFalse: this.setCacheBreakPicsFalse.bind(this),
      onClickedFullName: this.onClickedFullName.bind(this),
      showProgressIndicator: this.showProgressIndicator.bind(this),
      showTreeOverlay: this.showTreeOverlay.bind(this),
      openAddNodeForm: this.openAddNodeForm.bind(this),
      setCurZoomScaleWhenClicked: this.setCurZoomScaleWhenClicked.bind(this),
      canShowHyperlinkOut: this.canShowHyperlinkOut.bind(this),
      createImageElementForProfilePic: this.createImageElementForProfilePic.bind(this),
      translatedLabels: this.translatedLabels,
      showToolTipFor: this.showToolTipFor.bind(this),
      hideToolTip: this.hideToolTip.bind(this),
      skipZoomInOutSteppingNow: this.skipZoomInOutSteppingNow.bind(this),
      reloadCanvasTree: this.reloadCanvasTree.bind(this),
      setPedigreeAddbox: this.setPedigreeAddbox.bind(this),
      queueLocalStateUpdates: this.queueLocalStateUpdates.bind(this),
      releaseLocalStateUpdates: this.releaseLocalStateUpdates.bind(this),
      reloadFocusAndGotoHighlight: this.reloadFocusAndGotoHighlight.bind(this),
      hideProductTour: this.hideProductTour.bind(this),
      buildRefObj: this.buildRefObj.bind(this),
      callRefObj: this.callRefObj.bind(this),
    }

    let props = {
        nodeObj,
        ...nodeObj,
        ...methodProps,
        nodeObjs: this.nodeObjs,
        nodeSvgImg: assets.nodeSvgImg,
        nextNodeForPruning: this.state.nextNodeForPruning,
        isPedigree: this.props.isPedigree,
        nodeSpinnerGif: assets.nodeSpinnerGif,
        presummedDeadBannerImage: assets.presummedDeadBannerImage,
        deadBannerImage: assets.deadBannerImage,
        canvasTop: this.props.canvasTop,
        maleCustomColor: this.state.maleCustomColor,
        femaleCustomColor: this.state.femaleCustomColor,
        unGenderedCustomColor: this.state.unGenderedCustomColor,
        stageBackgroundCustomColor: this.state.stageBackgroundCustomColor,
        fontSizeChoice: this.state.fontSizeChoice,
        shadeLevel: this.state.shadeLevel,
        fullnameArrBasedOnFontSize: this.buildFullNameRowsBasedOnFontSize({nm: nodeObj.nm, n}),
        needEmail: this.needEmailFromNode(nodeObj.g_e)
    };

    const highlightNodeRef = {
      node: n,
      ref: `node-${n}`,
    }

    if(isDevelopment || isSeinfeld) {

      if( typeof(nodeObj) !== 'undefined' && typeof(nodeObj.focus) !== 'undefined' && nodeObj.focus === 1) {

        if(typeof(window.doThisOnceForDevStart) === 'undefined') window.doThisOnceForDevStart = false;

        if(!window.doThisOnceForDevStart){
          window.doThisOnceForDevStart = true;

          // console.log('devStartRef: ', highlightNodeRef);


        }
      }


    }

    this.highlightNodeRef = highlightNodeRef;

    // if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n})) this.FullNameComponentsArray.push(<FullName  {...props}  scaleX={this.stage.current.scaleX();} /> );

/*
    if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

    if(!window.doThisOnce){
      window.doThisOnce = true;

      console.log(`props: `, props);

    }*/

    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj})) {
      const fullnameProps = {
        ...props,
        nodeObjs: this.props.nodeObjs,
        dualPedigreeObj: this.props.dualPedigreeObj,
        showDualPedigreeModalChangeName: this.showDualPedigreeModalChangeName.bind(this),
        shouldHideChildrenForDualPedigree: this.shouldHideChildrenForDualPedigree.bind(this),
        isSingleChildForDualPedigree: this.isSingleChildForDualPedigree.bind(this),
        scaleX:this.stage.current.scaleX(),
        downloadingPedigreeChart: this.state.downloadingPedigreeChart,
      }
      const assembledFullNameArrayOfOne = assembleFullNameForOneNode(fullnameProps);
      this.FullNameComponentsArray = [...this.FullNameComponentsArray, ...assembledFullNameArrayOfOne];
    };
//         // this.FullNameComponentsArray = this.buildFullNameComponentsArray({props, nodeObj, FullNameComponentsArray: this.FullNameComponentsArray});

    const editRef = `edit_n-${n}`;

    if(1===2 && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n})) this.NodeSpinnerArray.push(<NodeSpinner  {...props}  /> );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj}) && !this.isPedigreePlaceHolder({nodeObj}) && this.canShowDateAlive({nodeObj})) this.DateAliveComponentsArray.push(
      <DateAlive  {...props}
        shouldHideChildrenForDualPedigree={this.shouldHideChildrenForDualPedigree.bind(this)}
        isSingleChildForDualPedigree={this.isSingleChildForDualPedigree.bind(this)}
        dualPedigreeObj={this.props.dualPedigreeObj} />
      );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && !isMobilePhone() && this.canEditnode({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart)this.EditComponentsArray.push(<Edit ref={editRef} {...props}  editNodeImg={assets.editNodeImg}/> );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && !isMobilePhone() && this.canEditnode({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.TransparentEditComponentsArray.push(<TransparentEditBox  {...props} /> );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && this.hasDna({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.DnaComponentsArray.push(<Dna  {...props}  dnaImg={assets.dnaImg}/> );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && this.hasDna({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.DnaBoxComponentsArray.push(<DnaBox  {...props}  /> );


    if( dualPedigreeMode && parseInt(n, 10) >= 0 ){

      const frameNodeRef = {
        node: n,
        ref: `node-${n}`,
      }
      this.FrameBorderComponentsArray.push(<FrameBorder {...props} {...frameNodeRef}
        nodeObj={nodeObj}
        shouldHideChildrenForDualPedigree={this.shouldHideChildrenForDualPedigree.bind(this)}
        isSingleChildForDualPedigree={this.isSingleChildForDualPedigree.bind(this)}
        cursorBecomesMove={this.cursorBecomesMove.bind(this)}
        cursorBecomesPointer={this.cursorBecomesPointer.bind(this)}
        showDualPedigreeModal={this.showDualPedigreeModal.bind(this)}
        notifyWithAtom={this.notifyWithAtom.bind(this)}
        countDualPedigreeImgLoaded={this.countDualPedigreeImgLoaded.bind(this)}
        forceUpdateCanvas={this.forceUpdateCanvas.bind(this)}
        highResolutionImagesForDualPedigree={this.state.highResolutionImagesForDualPedigree}
        innerFrameSideLengthAdjust={this.state.innerFrameSideLengthAdjust}
        innerFrameSideDownAdjust={this.state.innerFrameSideDownAdjust}
        innerFrameSideRightAdjust={this.state.innerFrameSideRightAdjust}
        cacheBreakPics={this.state.cacheBreakPics}
        placeholderImage_m={this.state.placeholderImage_m}
        placeholderImage_f={this.state.placeholderImage_f}
        placeholderImage_u={this.state.placeholderImage_u}
        setNodeObjPic={this.props.setNodeObjPic}
        dualPedigreeObj={this.props.dualPedigreeObj}
        postPoster={this.props.postPoster}
        canvasHeight={this.props.canvasHeight}
        zoomedFocusCompleteAfterInitialTreeLoad={this.zoomedFocusCompleteAfterInitialTreeLoad}/>
      );
    } else {
      if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && !isMobilePhone() && this.canEditnode({nodeObj}) && this.showDelete()) this.DeleteComponentsArray.push(<Delete  {...props}  /> );
      if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj}) && !this.isPedigreePlaceHolder({nodeObj}) && this.optionShowPic()) this.PicComponentArray.push(<Pic {...props}
        nodeObj={nodeObj}
        cacheBreakPics={this.state.cacheBreakPics}
        placeholderImage_m={this.state.placeholderImage_m}
        placeholderImage_f={this.state.placeholderImage_f}
        placeholderImage_u={this.state.placeholderImage_u}
        setNodeObjPic={this.props.setNodeObjPic}
        zoomedFocusCompleteAfterInitialTreeLoad={this.zoomedFocusCompleteAfterInitialTreeLoad}/>
      );

    }
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n)  && !dualPedigreeMode  && !this.state.downloadingPedigreeChart && this.nodeIsGhost({nodeObj, n}) && this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj})) this.GhostComponentArray.push(<GhostLabel  {...props} /> );
    if(this.onlyShowWhenScaleAbove() && this.nodeIsDeadPerson({nodeObj, n}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.DeadbannerComponentArray.push(<Deadbanner  {...props}  /> );
    if(this.onlyShowWhenScaleAbove() && this.nodeIsPresumedDeadPerson({nodeObj, n}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.PresumedDeadbannerComponentArray.push(<PresummedDeadBanner  {...props}  /> );
    if(this.showNodeOnTree(n) &&
      this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj}) && !dualPedigreeMode) {

      this.NodesComponentsArray.push(<Node {...props}  nodeObjs={this.props.nodeObjs} dropOnNode={this.state.dropOnNode}  /> );
    }
    if(this.showNodeOnTree(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.HighlightNodesComponentsArray.push(<HighLightNode {...highlightNodeRef } {...props}   /> );
    if(this.showNodeOnTree(n) && this.canShowPendingMerge({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.ShadowNodesComponentsArray.push(<ShadowNode {...props}   /> );


    /**
      *
      *
      *
      *   Invite
      *
      *
      *
     */

    if(( !isMobilePhone() &&
         !this.state.showMobileFlipCard &&
         !this.hideNodeComponentsWhenInviting(n)
       )
      ||
         isMobilePhone()
      ){
      const assembleInviteArrayOfOne = assembleInviteForOneNode({
        ...props,
        nodeObj,
        userTouchedNode: this.userTouchedNode.bind(this),
        panAnimateToNode: this.panAnimateToNode.bind(this),
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        invitationImage: assets.invitationImage,
        canEditnode: this.canEditnode.bind(this),
      });
      if(
        this.onlyShowWhenScaleAbove() &&
        this.showNodeOnTree(n)
        && this.needEmailFromNode(nodeObj.g_e) &&
        typeof(nodeObj.focus) === 'undefined' && !dualPedigreeMode && !this.state.downloadingPedigreeChart
      ) this.InviteComponentsArray  = [...this.InviteComponentsArray, ...assembleInviteArrayOfOne];
    }

    /**
      *
      *
      *
      *   Add node
      *
      *
      *
     */

      const assembleAddnodeTabArrayOfOne = assembleAddnodeTabForOneNode({
        ...props,
        userTouchedNode: this.userTouchedNode.bind(this),
        addnodetabImage: assets.addnodetabImage,
        lockTabImg: assets.lockTabImg,
        nearTabImg: assets.nearTabImg,
        addnodetabGreenImage: assets.addnodetabGreenImage,
        addnodetabRedImage: assets.addnodetabRedImage,
        moretabImage: assets.moretabImage,
        addnodetabYellowImage: assets.addnodetabYellowImage,
        onclickedAddNodeTab:this.onclickedAddNodeTab.bind(this),
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        callHookForMessageAlert: this.callHookForMessageAlert.bind(this),
        hideMatchBubble: this.hideMatchBubble.bind(this),
      });


      if( this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && this.canAddnode({nodeObj}) && !isMobilePhone() && !this.nodeIsGhost({nodeObj, n}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) {
          this.AddNodeComponentsArray  = [...this.AddNodeComponentsArray, ...assembleAddnodeTabArrayOfOne];
      }

    /**
      *
      *
      *
      *   Multiple Parents
      *
      *
      *
     */

    if(this.canChangeDifferentParent(nodeObj) && !dualPedigreeMode && !this.state.downloadingPedigreeChart){
      const assembleMultipleParentsOfOne = assembleMultipleParentsForOneNode({
        ...props,
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        userTouchedNode: this.userTouchedNode.bind(this),
      });
      if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n)) this.MultipleParentsComponentsArray  = [...this.MultipleParentsComponentsArray, ...assembleMultipleParentsOfOne];
    }


    /**
      *
      *
      *
      *   Cycle through similiar nodes in the tree
      *
      *
      *
     */

    if( ( typeof(nodeObj.cids) !== 'undefined' && !this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) ||
        (typeof(nodeObj.nt) !== 'undefined' && nodeObj.nt === 'cc' &&
          !this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) ){

      const cycleProps = {
        ...props,
        nodeObjs: this.nodeObjs,
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        animateThroughCycleNodes: this.animateThroughCycleNodes.bind(this),
        userTouchedCycle: this.userTouchedCycle.bind(this),
      };
      const assembledCycleArrayOfOne = assembleCycleForOneNode(cycleProps);
      if(this.onlyShowWhenScaleAbove() &&
        this.showNodeOnTree(n) &&
        this.canShowCycleCount({nodeObj})){
        this.CycleComponentsArray = [...this.CycleComponentsArray, ...assembledCycleArrayOfOne];
      }

    }

    /**
      *
      *
      *
      *   Prune Tree
      *
      *
      *
     */

    const pruneTreeProps = {
        ...props,
        setPrId,
        fetchTree,
        toggleFlipPanel: this.toggleFlipPanel.bind(this),
        resetNavDirectionControls: this.resetNavDirectionControls.bind(this),
        unSetStageClickCanZoomStep: this.unSetStageClickCanZoomStep.bind(this),
        setStageClickCanZoomStep: this.setStageClickCanZoomStep.bind(this),
        zoomOutFromMobileFlipCard: this.zoomOutFromMobileFlipCard.bind(this),
        setDidRequestLoadTreeToTrue: this.setDidRequestLoadTreeToTrue.bind(this),
        showProgressIndicator: this.showProgressIndicator.bind(this),
        reloadWithNewTree: this.reloadWithNewTree.bind(this),
        panAnimateToNode: this.panAnimateToNode.bind(this),
        setNextNodeForPruning: this.setNextNodeForPruning.bind(this),
        setPushToHistory: this.setPushToHistory.bind(this),
        prunetreeImage: assets.nodeSvgImg,
        pruneImg: assets.pruneImg,
        baretreeImg: assets.baretreeImg,
        userTouchedNode: this.userTouchedNode.bind(this),
        callSetPageProfile: this.callSetPageProfile.bind(this),
        setFlipPanelOpenAfterAnimateComplete: this.setFlipPanelOpenAfterAnimateComplete.bind(this),
        toggleNavigationalPanel: this.toggleNavigationalPanel.bind(this),
        resetNavigationState: this.resetNavigationState.bind(this),
      };

    if(this.onlyShowWhenScaleAbove() && typeof(nodeObj.p) !== 'undefined' &&
       ! this.hideNodeComponentsWhenInviting(n) &&
       this.canShowPruneTree({nodeObj})
      ){

      const assembledPruneTreeArrayOfOne = assemblePruneTreeForOneNode(pruneTreeProps);
      if(this.showNodeOnTree(n)) this.PruneTreeComponentsArray = [...this.PruneTreeComponentsArray, ...assembledPruneTreeArrayOfOne];
      if( urlGet('no_decoration') || no_decoration){ this.PruneTreeComponentsArray  = [];}
    }

    const treeRef = `tree_n-${n}`;
    if(this.onlyShowWhenScaleAbove() && typeof(nodeObj.focus) === 'undefined' && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && !isMobilePhone() && this.canClickTreeLink({nodeObj}) && !this.isPedigreePlaceHolder({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.TreelinkComponentsArray.push(<Treelink  ref={treeRef} {...pruneTreeProps}   treeImg={assets.treeImg}/>);
    if(this.onlyShowWhenScaleAbove() && typeof(nodeObj.focus) === 'undefined' && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && !this.nodeIsGhost({nodeObj, n}) && !isMobilePhone() && this.canClickTreeLink({nodeObj}) && !this.isPedigreePlaceHolder({nodeObj}) && !dualPedigreeMode && !this.state.downloadingPedigreeChart) this.TransparentTreeComponentsArray.push(<TransparentTreeBox   {...pruneTreeProps}   {...props} /> );
    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && this.canShowResolveWarning({nodeObj}) &&
      !this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart
    ){
      this.ResolveWarningComponentsArray.push(<ResolveWarning
        {...props}
        nodeObjs={this.nodeObjs}
        waringImage={assets.waringImage}
        fetchResolveAndPopModal={this.fetchResolveAndPopModal.bind(this)}
      />);

      screenCanShowModal({minWidth:900}) &&
      this.TransparentResolveComponentsArray.push(<TransparentResolveWarning
        {...props}
        userTouchedNode={this.userTouchedNode.bind(this)}
        nodeObjs={this.nodeObjs}
        fetchResolveAndPopModal={this.fetchResolveAndPopModal.bind(this)}
      />);


    }

    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && this.canShowPendingMerge({nodeObj}) &&
      !this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart
    ){
      this.PendingMergeComponentsArray.push(<PendingMerge
        {...props}
        nodeObjs={this.nodeObjs}
        mergemoveImage={assets.mergemoveImage}
        waringImage={assets.waringImage}
      />);

      this.TransparentPendingMergeComponentsArray.push(<TransparentPendingMerge
        {...props}
        userTouchedNode={this.userTouchedNode.bind(this)}
        nodeObjs={this.nodeObjs}
      />);


    }

    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(n) && this.canShowInconsistency({nodeObj}) &&
      !this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart
    ){
      this.InconsistencyTextComponentsArray.push(<InconsistencyText
        {...props}
        nodeObjs={this.nodeObjs}
      />);

      this.InconsistencyCircleTextComponentsArray.push(<InconsistencyCircle
        {...props}
        nodeObjs={this.nodeObjs}
      />);

      this.TransparentInconsistencyCircleArray.push(<TransparentInconsistencyCircle
        {...props}
        userTouchedNode={this.userTouchedNode.bind(this)}
        nodeObjs={this.nodeObjs}
      />);
    }





    /**
      *
      *
      *
      *   Matches Bubble
      *
      *
      *
     */

    if(this.onlyShowWhenScaleAbove() && typeof(nodeObj.nn) !== 'undefined' &&
       ! this.hideNodeComponentsWhenInviting(n) && !dualPedigreeMode && !this.state.downloadingPedigreeChart
    ){ // nn appears in fetch_profiles

      const matchBubbleProps = {
        ...props,
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        showMatchBubbleFor: this.showMatchBubbleFor.bind(this),
        nodeShownInMatchBubble: this.state.nodeShownInMatchBubble,
        zoomOutFromMobileFlipCard: this.zoomOutFromMobileFlipCard.bind(this),
        magnifyImage: assets.magnifyImage,
        smartImg: assets.smartImg,
        recordImg: assets.recordImg,
        geniImg: assets.geniImg,
        fillMatchBubbleContent: this.fillMatchBubbleContent.bind(this),
        matchBubbleContent: this.state.matchBubbleContent,
        matchBubbleContentVarStr: this.state.matchBubbleContentVarStr,
      };

      const matchCount = parseInt(nodeObj.match_count, 10);

      const assembledMagnifyCountArrayOfOne = assembleMagnifyCountForOneNode(matchBubbleProps);
      if(this.showNodeOnTree(n) &&  matchCount > 0){ this.MagnifyCountComponentsArray  = [...this.MagnifyCountComponentsArray , ...assembledMagnifyCountArrayOfOne];
      }  else if(this.showNodeOnTree(n)){
        if(this.hasGedcom({nodeObj})) this.GedcomComponentsArray.push(<Gedcom  {...props}  gedcomImg={assets.gedcomImg}/> );
        if(isMobileTablet() && this.hasGedcom({nodeObj})) this.GedcomTransparentBoxArray.push(<GedcomTransparentBox  {...props} /> );
      }

      if( (isDevelopment && urlGet('rmn') && n === urlGet('rmn')) || (isDevelopment && urlGet('tmn')&& n === urlGet('tmn')) ||
          (isSeinfeld && urlGet('rmn') && n === urlGet('rmn')) || (isSeinfeld && urlGet('tmn')&& n === urlGet('tmn'))
      ){
         this.MagnifyCountComponentsArray  = [...this.MagnifyCountComponentsArray , ...assembledMagnifyCountArrayOfOne];
      }

      if(n === this.state.nodeShownInMatchBubble ){
        const assembledBubbleArrayOfOne = assembleBubbleForOneNode(matchBubbleProps);
        if(this.showNodeOnTree(n) &&  matchCount > 0) {
          this.MatchesBubbleComponentsArray = [...this.MatchesBubbleComponentsArray, ...assembledBubbleArrayOfOne];
        }
      }

      if( (isDevelopment && urlGet('rmn') && n === urlGet('rmn')) || (isDevelopment && urlGet('tmn')&& n === urlGet('tmn')) ||
          (isSeinfeld && urlGet('rmn') && n === urlGet('rmn')) || (isSeinfeld && urlGet('tmn')&& n === urlGet('tmn'))
      ){
        const assembledBubbleArrayOfOne = assembleBubbleForOneNode(matchBubbleProps);
        this.MatchesBubbleComponentsArray = [...this.MatchesBubbleComponentsArray, ...assembledBubbleArrayOfOne];
      }
      if( urlGet('no_decoration') || no_decoration){ this.MagnifyCountComponentsArray  = [];}
    }

    /**
      *
      *
      *
      *   Tooltip Bubble
      *
      *
      *
     */

    if(
      this.onlyShowWhenScaleAbove() &&
      typeof(nodeObj.nn) !== 'undefined' &&
      !this.hideNodeComponentsWhenInviting(n) &&
      n === this.state.nodeShownInToolTip
    ){

      const tooltopBubbleProps = {
        ...props,
        stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
        nodeShownInToolTip: this.state.nodeShownInToolTip,
        contentShownInToolTip: this.state.contentShownInToolTip,
        runTranslatePhraseInToolTip: this.state.runTranslatePhraseInToolTip,
        translateVarStrInToolTip: this.state.translateVarStrInToolTip,
        placementShownInToolTip: this.state.placementShownInToolTip,
        bubbleWidth: this.state.bubbleWidth,
        shiftLeftOnToolTip: this.state.shiftLeftOnToolTip,
        shiftTopOnToolTip: this.state.shiftTopOnToolTip,
        okLabelInToolTip: this.state.okLabelInToolTip,
        okLabelWidthInToolTip: this.state.okLabelWidthInToolTip,
        confirmLabelWidthInToolTip: this.state.confirmLabelWidthInToolTip,
        confirmLabelInToolTip: this.state.confirmLabelInToolTip,
        okCallbackInToolTip: this.state.okCallbackInToolTip,
        confirmCallbackInToolTip: this.state.confirmCallbackInToolTip,
      };

      const assembledToolTipForOneNode = assembleToolTipForOneNode(tooltopBubbleProps);
      if(this.showNodeOnTree(n) ) this.ToolTipComponentsArray = [...this.ToolTipComponentsArray, ...assembledToolTipForOneNode];
    }
  }

  assembleTree(){

    const {
      unions,
      nodeObjs,
      branches,
      viewPortSides,
    } = this.props;

    this.nodeObjs = window.nodeObjs = nodeObjs;
    this.unions = window.unions = unions;
    this.NodesComponentsArray = [];
    this.ViewportComponentsArray= [];
    this.HighlightNodesComponentsArray = [];
    this.ShadowNodesComponentsArray = [];
    this.FullNameComponentsArray = [];
    this.NodeSpinnerArray = [];
    this.DateAliveComponentsArray = [];
    this.EditComponentsArray = [];
    this.TransparentEditComponentsArray = [];
    this.TreelinkComponentsArray = [];
    this.ResolveWarningComponentsArray = [];
    this.TransparentResolveComponentsArray = [];
    this.PendingMergeComponentsArray = [];
    this.TransparentPendingMergeComponentsArray = [];
    this.InconsistencyTextComponentsArray = [];
    this.InconsistencyCircleTextComponentsArray = [];
    this.TransparentInconsistencyCircleArray = [];
    this.TransparentTreeComponentsArray = [];
    this.DnaComponentsArray = [];
    this.DnaBoxComponentsArray = [];
    this.GedcomComponentsArray = [];
    this.GedcomTransparentBoxArray = [];
    this.DeleteComponentsArray = [];
    this.PicComponentArray = [];
    this.FrameBorderComponentsArray = [];
    this.GhostComponentArray = [];
    this.DeadbannerComponentArray = [];
    this.PresumedDeadbannerComponentArray = [];
    this.CycleIconComponentsArray = [];
    this.CycleCountComponentsArray = [];
    this.CycleComponentsArray = [];
    this.MagnifyCountComponentsArray = [];
    this.MatchesBubbleComponentsArray = [];
    this.ToolTipComponentsArray = [];
    this.PruneTreeComponentsArray = [];
    this.InviteComponentsArray = [];
    this.AddNodeComponentsArray = [];
    this.MultipleParentsComponentsArray = [];
    this.PedbranchComponentsLinesArray = [];
    this.PedbranchComponentsAddTabArray = [];

    if(this.props.isPedigree && !this.state.nextNodeForPruning  ){

      const pedigreerbranchProps = {
                nodeObjs,
                canvasHeight: this.props.canvasHeight,
                canvasWidth: this.props.canvasWidth,
                forceUpdateCanvas: this.forceUpdateCanvas.bind(this),
                stopStageClickPropagation: this.stopStageClickPropagation.bind(this),
                cursorBecomesMove: this.cursorBecomesMove.bind(this),
                cursorBecomesPointer: this.cursorBecomesPointer.bind(this),
                showDualPedigreeModalChangeName: this.showDualPedigreeModalChangeName.bind(this),
                reloadCanvasTree: this.reloadCanvasTree.bind(this),
                setPedigreeAddbox: this.setPedigreeAddbox.bind(this),
                userTouchedNode: this.userTouchedNode.bind(this),
                shouldHideChildrenForDualPedigree: this.shouldHideChildrenForDualPedigree.bind(this),
                onclickedAddNodeTab: this.onclickedAddNodeTab.bind(this),
                triggerPedigreeCalloutForNode: this.triggerPedigreeCalloutForNode.bind(this),
                panAnimateCenterPedigree: this.panAnimateCenterPedigree.bind(this),
                panAnimateToNode: this.panAnimateToNode.bind(this),
                launchNotifyModalForPedigreeFromTabComponent: this.launchNotifyModalForPedigreeFromTabComponent.bind(this),
                pedigreeAddboxVisible: this.state.pedigreeAddboxVisible,
                downloadingPedigreeChart: this.state.downloadingPedigreeChart,
                dualPedigreeObj: this.props.dualPedigreeObj,
                stage: this.stage,
              };

      this.pedigreeAddTabObj = {};

      branches.forEach((branch) => {
        const PedbranchAssembledArrayLinesOfOne = assemblePedbranchLines({
                branch,
                ...pedigreerbranchProps,
              });

        const PedbranchAssembledArrayAddTabOfOne = assemblePedbranchAddTab({
                pedigreeAddTabObj: this.pedigreeAddTabObj,
                branch,
                ...pedigreerbranchProps,
              });

        this.PedbranchComponentsLinesArray = [...this.PedbranchComponentsLinesArray, ...PedbranchAssembledArrayLinesOfOne];
        if(!dualPedigreeMode && !this.state.downloadingPedigreeChart) this.PedbranchComponentsAddTabArray = [...this.PedbranchComponentsAddTabArray, ...PedbranchAssembledArrayAddTabOfOne];
      })
    }

    // console.count('assembling...');

    var nodeObj = {};

    if(this.props.isPedigree){

     for (let n in nodeObjs) {

        nodeObj = nodeObjs[n];

        if( isNodeWithinViewport( {nodeObj, viewPortSides, viewPortBuffer})) {
          if(typeof(nodeObj) !== 'undefined' ) this.gatherTreeComponents({n, nodeObj});
        }

      }

    } else {

      const { viewPortNodes } = this.buildViewPortNodes({viewPortSides});
      // console.log(`viewPortNodes: `, JSON.stringify(viewPortNodes, null, 2));
      // console.log(`nodes in viewport: `, viewPortNodes.length);
      // document.getElementById("debugDiv2").innerHTML = 'Size in viewport: ' + viewPortNodes.length
      for (let idx = 0; idx < viewPortNodes.length; idx++) {

        var n = viewPortNodes[idx].toString();

        nodeObj = nodeObjs[n];

        if(typeof(nodeObj) !== 'undefined' ) this.gatherTreeComponents({n, nodeObj});

      }

    }


    if( this.showDragNodeWhenCntrlKeyDn()) {
      this.DragNode = <DragNode
        focus={1}
        dragNodeObj={this.state.dragNodeObj}
        nodeObjs={this.nodeObjs}
        dropOnNode={this.state.dropOnNode}
        launchMoveDecisonPanel={this.launchMoveDecisonPanel.bind(this)}
        confirmDropOnGhost={this.confirmDropOnGhost.bind(this)}
        setActivateDesignateDragOrDropTarget={this.setActivateDesignateDragOrDropTarget.bind(this)}
        dropOnTargetForCtrlKeyDnMoveFeature={this.dropOnTargetForCtrlKeyDnMoveFeature.bind(this)}
        setMouseMovementActionMode_ForCntrlDnMoveFeature={this.setMouseMovementActionMode_ForCntrlDnMoveFeature.bind(this)}
        setDropOnNode={this.setDropOnNode.bind(this)}
        maleCustomColor={this.state.maleCustomColor}
        femaleCustomColor={this.state.femaleCustomColor}
        placeholderImage_m={this.state.placeholderImage_m}
        placeholderImage_f={this.state.placeholderImage_f}
        placeholderImage_u={this.state.placeholderImage_u}
        unGenderedCustomColor={this.state.unGenderedCustomColor}
        fontSizeChoice={this.state.fontSizeChoice}
      />;
    }

    this.LinesComponentsArray = [];
    this.GoalPostComponentsArray = [];
    this.TComponentsArray = [];
    let exNodes = [];

    !this.props.isPedigree && unions.forEach((union) => {

      if(  isUnionWithinViewport({union, nodeObjs, viewPortSides})) {
        if(unionIsPartnersOfTwoNodes(union)) {
          var lineCoorsProp = getUnionLineCoordsForPartners({ union, nodeObjs });
          exNodes.push(lineCoorsProp.exNode);
          var unionIsRelated = bothPartnersDirectlyRelated(union, nodeObjs);
        } else{ // Single parent conceives offspring
          // console.log('>>>>>>>>>>>>>>>>>>', 'Single parent conceives offspring', union.p[0]);
        }
        if( unionHasDescedants(union) ){
          var centerXFromChildren = getCenterXFromChildren(union.c, nodeObjs);
          if(isUnionAboveGrandparentNodeRowNrelated(union, nodeObjs)){
            const GoalPostAssembledArrayOfOne = assembleGoalPost({ union, nodeObjs, unionIsRelated, centerXFromChildren, stageBackgroundCustomColor: this.state.stageBackgroundCustomColor });
            this.GoalPostComponentsArray = [...this.GoalPostComponentsArray, ...GoalPostAssembledArrayOfOne];
          } else {
            const TAssembledArrayOfOne = assembleT({ union, nodeObjs, lineCoorsProp, unionIsRelated, centerXFromChildren, stageBackgroundCustomColor: this.state.stageBackgroundCustomColor });
            this.TComponentsArray = [...this.TComponentsArray, ...TAssembledArrayOfOne];
          }
        } else{
          if(unionIsPartnersOfTwoNodes(union)) {
            this.LinesComponentsArray.push(
              <Unionline key={union.u} {...lineCoorsProp} {...{union, nodeObjs}} {...{stageBackgroundCustomColor: this.state.stageBackgroundCustomColor}}/>
            );
          } else{ // Single parent conceives offspring
            // console.log('>>>>>>>>>>>>>>>>>>', 'Single parent conceives offspring', union.p[0]);
          }
        }

      }

    });


    this.UnionsComponentsArray = [...this.LinesComponentsArray, ...this.GoalPostComponentsArray, ...this.TComponentsArray];

    resetSideYPointIdx({nodes: exNodes, nodeObjs: this.props.nodeObjs});

    // this.ViewportComponentsArray.push(
    //     <Viewport
    //       key={1}
    //       {...{
    //         left: viewPortSides.left,
    //         top:  viewPortSides.top,
    //         right: viewPortSides.right,
    //         bottom:  viewPortSides.bottom,
    //       }}
    //     />);


  }

}
